import { render } from "./DjQueryTab.vue?vue&type=template&id=4dd36e7a&scoped=true"
import script from "./DjQueryTab.vue?vue&type=script&lang=js"
export * from "./DjQueryTab.vue?vue&type=script&lang=js"

import "./DjQueryTab.vue?vue&type=style&index=0&id=4dd36e7a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4dd36e7a"

export default script